import React, { useState } from 'react';
import './App.css';
import WhoImageSlider from './WhoImageSlider';
import TestimonialSlider from './TestimonialSlider';
import TeamScreen from './TeamScreen';
import ContactScreen from './ContactScreen';
import Header from './Header';
import ModalForm from './ModalForm'; // Добавляем импорт ModalForm

import Screen1 from './media/land1.png';
import Screen2 from './media/Screen2.png';
import Screen4 from './media/Screen4.png';
import Screen5 from './media/Screen5.png';
import Screen6 from './media/Screen6.png';

function App() {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Добавляем состояние для модального окна

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsActive(false);
  };

  const handleMouseDown = () => {
    setIsActive(true);
  };

  const handleMouseUp = () => {
    setIsActive(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="App">
      {/* Передаем функцию openModal в Header */}
      <Header onOpenModal={openModal} />
      
      <div className="screen-container">
        <img src={Screen1} alt='screen1' className="screen-image" />
        
        {/* Кнопка размещена поверх изображения */}
        <button 
          className="screen-button"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onClick={openModal} // Добавляем обработчик клика
          style={{
            background: isActive 
              ? '#1A62CE' 
              : isHovered 
                ? 'linear-gradient(52.6deg, #91BCFF -27.08%, #5196FF 66.71%)' 
                : 'linear-gradient(48.56deg, #5196FF 35.12%, #91BCFF 96.57%)'
          }}
        >
          Оставить заявку
        </button>
      </div>
      
      <img 
        src={Screen2} 
        alt="screen2" 
        style={{ marginTop: '100px' }} 
      />

      {/* Экран со слайдером карточек */}
      <section id="для-кого">
        <WhoImageSlider />
      </section>
      
      <section id="о-сервисе">
        <div className="screen-container2">
          <img src={Screen4} alt='screen4' className="screen-image2" />
          
          {/* Кнопка размещена поверх изображения */}
          <button 
            className="screen-button2"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onClick={openModal} // Добавляем обработчик клика
            style={{
              background: isActive 
                ? '#1A62CE' 
                : isHovered 
                  ? 'linear-gradient(52.6deg, #91BCFF -27.08%, #5196FF 66.71%)' 
                  : 'linear-gradient(48.56deg, #5196FF 35.12%, #91BCFF 96.57%)'
            }}
          >
            Задать вопрос
          </button>
        </div>
      </section>
      
      <section id="как-работает">
        <img 
          src={Screen5} 
          alt="screen5" 
          style={{ marginTop: '100px' }} 
        />
        <img 
          src={Screen6} 
          alt="screen6" 
          style={{ marginTop: '100px' }} 
        />
      </section>
      
      <TestimonialSlider />
      
      <section id="команда">
        <TeamScreen />
      </section>
      
      <section id="контакты">
        <ContactScreen />
      </section>

      {/* Добавляем модальное окно */}
      <ModalForm isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default App;